import type { Color } from "../../types";
import type { HasAverageColor } from "../HasAverageColor";
import type { HasBackgroundColor } from "../HasBackgroundColor";
import type { VirtualViewportPixelAccessor } from "../VirtualViewportPixelAccessor";
import { AbstractVirtualPixelDecorator } from "./AbstractVirtualPixelDecorator";

/**
 * Mirror virtual pixel decorator.
 */
export class MirrorVirtualPixel<
  DecoratedType extends VirtualViewportPixelAccessor &
    HasAverageColor &
    HasBackgroundColor
> extends AbstractVirtualPixelDecorator<DecoratedType> {
  /**
   * @inheritDoc
   */
  getVirtualPixelColor(x: number, y: number): Color {
    const doubleWidth = this.width * 2;
    const doubleHeight = this.height * 2;
    const rx = x % doubleWidth;
    const ry = y % doubleHeight;
    let tx = rx < 0 ? doubleWidth + rx : rx;
    let ty = ry < 0 ? doubleHeight + ry : ry;
    if (tx > this.width - 1) {
      tx = this.width - (tx - this.width) - 1;
    }
    if (ty > this.height - 1) {
      ty = this.height - (ty - this.height) - 1;
    }
    return this.decorated.getPixelColor(tx, ty);
  }
}
